import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="center-state">
      <div style={{ textAlign: 'center' }}>
        <div className="serif" style={{ fontSize: 22, color: 'var(--ink-soft)', marginBottom: 8 }}>
          Not found
        </div>
        <Link to="/" className="avbp-lnk">
          Back to portal
        </Link>
      </div>
    </div>
  );
}
